// @flow

import React, { Component } from 'react';
import DatePicker from 'material-ui/DatePicker';
import FlatButton from 'material-ui/FlatButton';
import { Icon } from 'react-fa';
import _ from 'lodash';
import moment from 'moment';

import App, { get_state_collect } from './App.jsx';
import Map from './Map.jsx';

import { abrev, takeDir } from './utils.js';

import { CLASSIC_WIDTH, SIDEBAR_WIDTH, ms_icons } from './consts.js';

import type { T_CollectPoint, T_CollectFolder } from './types.js';

import './css/CollectPoints.css';


const { DateTimeFormat } = Intl;



type T_CollectPointsProps = {
  app: App,
  collect: T_CollectFolder,
  show_tree: boolean
};



type T_CollectPointsState = {
  date1: string,
  date2: string,
  buscar: string,
  manejo: string,
  points: Array<T_CollectPoint>,
  isUPL: boolean,
  opened: number,
  tipos_manejos: Array<string>
};



const ICON_NUM = 5;     // índice del ícono dentro del árray ms_icons



const DateSty = { border: 0, width: 90, maxWidth: 90 };




export default class CollectPoints extends Component<T_CollectPointsProps, T_CollectPointsState> {
  gsel_dot: ?Object;
  gpoints: Array<Object>;


  state = {
    date1: 'NO',
    date2: 'NO',
    buscar: '',
    manejo: 'Todos',
    points: this.props.collect.points,
    isUPL: this.props.collect.points.length ? takeDir(this.props.collect.points[0].path_predio).includes('/MAPS/UPL/') : false,
    opened: -1,
    tipos_manejos: []
  };



  click_dot(dot: Object): void {
    if (this.gsel_dot) {
      this.gsel_dot.setIcon(ms_icons[ICON_NUM].normal);
    }

    this.gsel_dot = dot;

    dot.setIcon(ms_icons[ICON_NUM].hilight);
  }



  componentDidMount() {
    this.gpoints = [];
    this.gsel_dot = null;

    const { app } = this.props,
      { map } = app.map_ui.map;

    app.collect = this;

    if (this.state.isUPL) {
      const tipos_manejos = [
        'Siembra-Plantación',
        'Crecimiento-Desarrollo',
        'Fertilización',
        'Maleza',
        'Enfermedades',
        'Plagas',
        'Riego',
        'Aplicación de Insumo',
        'Clima',
        'Cosecha',
        'Otros',
      ];

      tipos_manejos.unshift('Todos');

      this.setState({ tipos_manejos });
    } else {
      fetch(`${app.remote}/collect-lista-manejos/?session_id=${app.session()}`).then(resp => resp.json()).then((tipos_manejos: Array<string>) => {
        tipos_manejos.unshift('Todos');
  
        this.setState({ tipos_manejos });
      });
    }

    if (Map.google != null && Map.vec2LL != null) {
      const { google, vec2LL } = Map;

      for (const point of this.state.points) {
        const { lat, lon } = point,
          position = vec2LL([lat, lon]),
          dot = new google.Marker({ position, map, icon: ms_icons[ICON_NUM].normal });

        this.gpoints.push(dot);

        google.event.addListener(dot, 'click', (ev) => {
          this.click_dot(dot);

          this.open_point(point);
        });
      }
    }
  }



  componentWillUnmount() {
    this.props.app.collect = null;

    if (Map.google != null) {
      const { google } = Map;

      for (const gpoint of this.gpoints) {
        google.event.clearInstanceListeners(gpoint);

        gpoint.setMap(null);
      }
    }
  }



  hide_if_not_found = (): void => {
    let found = true;

    if (this.state.opened !== -1) {
      found = this.props.collect.points[this.state.opened].found;     // eslint-disable-line prefer-destructuring
    }

    this.props.app.setState({
      cond_show_collect_point: found,
      cond_show_jpg: found
    });
  };



  search = (): void => {
    const m1 = this.state.date1 !== 'NO' ? moment(this.state.date1).startOf('day') : null,
      m2 = this.state.date2 !== 'NO' ? moment(this.state.date2).endOf('day') : null;

    this.setState({
      points: this.props.collect.points.filter((point: T_CollectPoint): boolean => {
        let c1 = true,
          c2 = true,
          c3 = true,
          c4 = true;

        if (m1)
          c1 = point.fmoment.isAfter(m1);

        if (m2)
          c2 = point.fmoment.isBefore(m2);

        if (this.state.buscar)
          c3 = point.nota.indexOf(this.state.buscar) !== -1;

        if (this.state.manejo !== 'Todos')
          c4 = _.includes(point.manejos, this.state.manejo);

        point.found = c1 && c2 && c3 && c4;

        this.gpoints[point.id].setVisible(point.found);

        return point.found;
      })
    }, this.hide_if_not_found);
  };



  set_date1 = (unused: Object, date1: Date): void => {
    this.setState({ date1: date1.toJSON() }, this.search);
  };



  set_date2 = (unused: Object, date2: Date): void => {
    this.setState({ date2: date2.toJSON() }, this.search);
  };



  change_buscar = (ev: SyntheticInputEvent<*>): void => {
    this.setState({ buscar: ev.target.value }, this.search);
  };



  open_point = (point: T_CollectPoint): void => {
    const { app } = this.props,
      already_opened = app.state.collect_point_opened != null && app.state.collect_point_opened.id === point.id;

    app.setState({
      collect_point_opened: (already_opened ? null : point),
      show_jpg_url: '',
      show_jpg_title: '',
      cond_show_collect_point: true,
      cond_show_jpg: true
    });

    this.setState({ opened: (already_opened ? -1 : point.id) });

    if (already_opened) {
      this.gpoints[point.id].setIcon(ms_icons[ICON_NUM].normal);

      this.gsel_dot = null;
    }
    else {
      this.click_dot(this.gpoints[point.id]);
    }
  };



  show_point = (point: T_CollectPoint, index: number) => {
    const sel = this.state.opened === point.id;
    
    const fecha = point.fecha.split(' ');
    
    const time = fecha[1].split(':');

    const _date = fecha[0].split('-').reverse().join('-');
    const _time = time[0] + ':' + time[1]; 
    const _manejo = takeDir(point.path_predio).includes('/MAPS/UPL') ?
      point.labor : point.manejos[0];
      
    return (
      <span key={index} onClick={() => this.open_point(point)} style={{ fontWeight: sel ? 'bold' : 'normal' }}>
        {_date} {_time} {!!_manejo ? `- ${_manejo}` : null}
      </span>
    );
    /* takeDir(point.path_predio).includes('/MAPS/UPL') ?
      !!point.labor ?
      `${_date} ${_time} - ${point.labor}` : point.fecha
      : abrev(point.nota, 30) */
  };



  close = (): void => {
    const { app } = this.props;

    app.setState(get_state_collect(null), () => {
      if (app.item_collect != null) {
        app.item_collect.unclick();

        app.item_collect = null;
      }
    });
  }



  view_all = (): void => {
    this.setState({ buscar: '' }, this.search);
  }



  change_manejo = (ev: SyntheticInputEvent<*>): void => {
    this.setState({ manejo: ev.target.value }, this.search);
  };



  render() {
    return (
      <div className='Collect' style={{ left: SIDEBAR_WIDTH + (this.props.show_tree ? CLASSIC_WIDTH : 0) + 17 }}>
        <p className='CollectLogo'>
          <img src='img/logo_collect.png' alt='' />
        </p>

        <div>
          <input type='text' value={this.state.buscar} placeholder='Buscar...' onChange={this.change_buscar} />

          <button onClick={this.view_all}>
            <Icon name='undo' />
          </button>

          <p className='CollectFiltrar'>
            Filtrar búsqueda por:
          </p>

          <div className='ColDate'>
            <div>Fecha:</div>

            <DatePicker
              hintText='Desde'
              hideCalendarDate={true}
              DateTimeFormat={DateTimeFormat}
              locale='es'
              mode='landscape'
              onChange={this.set_date1}
              id='bk_date1'
              textFieldStyle={DateSty}
            />

            <DatePicker
              hintText='Hasta'
              hideCalendarDate={true}
              DateTimeFormat={DateTimeFormat}
              locale='es'
              mode='landscape'
              onChange={this.set_date2}
              id='bk_date2'
              textFieldStyle={DateSty}
            />
          </div>

          <div className='divManejo'>
            <span>
              Tipo de manejo:
            </span>

            <select onChange={this.change_manejo} defaultValue='Todos'>
              {this.state.tipos_manejos.map((manejo, index) => <option value={manejo} key={index}>{manejo}</option>)}
            </select>
          </div>
        </div>

        <p className='CollectResult'>
          Resultados:
        </p>

        <div className='points_found'>
          {_.sortBy(this.state.points, ['funix']).map(this.show_point)}
        </div>

        <div style={{ textAlign: 'center' }}>
          <FlatButton label='Cerrar' onClick={this.close} primary={true} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/CollectPoints.jsx